'use strict';

var AppliedStrategyPanelDirective = function AppliedStrategyPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/applied-strategy.html'),
    controller: 'AppliedStrategyPanelController',
    requires: '^rmRuleCustom',
    link: function link($scope, element) {
      $scope.$on('grid:rowSelectionChanged', $scope.selectionChanged);
      $scope.$on('grid:afterUpdateBoundData', $scope.newGridDataLoaded);
      $scope.$watch('strategiesPanelVisible', function () {
        if ($scope.strategiesPanelVisible) {
          $scope.preselectedRowsReadyForCheck = false;
        }
      });
    }
  };
};
AppliedStrategyPanelDirective.$inject = [];
module.exports = AppliedStrategyPanelDirective;